import { useState, useEffect } from "react";
import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import { useParams } from "react-router-dom";
import IsError from "Components/RequestHandler/IsError";
const UppcomingCourses = () => {
  const { slug } = useParams();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`academy-training-and-workShop/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className="scroll-section-special">
        <Hero title={data?.course_title} />
        <Landing title={data?.course_title} data={data?.course_details} />
      </main>
    );
  }
};

export default UppcomingCourses;
